export const gitCommit = 'b0b761f3'
